// Vendor-independent adblock detection: a bait element styled like an ad.
// Cosmetic filter lists hide elements with these class names; if the bait is
// collapsed/hidden after insertion, a blocker is active. One signal among two —
// the other is the vendor ad script being killed (see providers/adsterra.ts).

let cached: boolean | null = null

export async function detectAdblockBait(): Promise<boolean> {
  if (cached !== null) return cached
  try {
    const bait = document.createElement('div')
    bait.className = 'ad_banner adsbox ad-placement ad-unit textads banner-ads'
    bait.style.cssText = 'position:absolute;left:-9999px;top:-9999px;width:10px;height:10px;'
    document.body.appendChild(bait)
    await new Promise((r) => setTimeout(r, 80))
    cached = bait.offsetHeight === 0 || bait.offsetParent === null
      || getComputedStyle(bait).display === 'none'
    bait.remove()
  } catch {
    cached = false // detection failure must never count as adblock
  }
  return cached
}

/** Test hook: reset the cached result. */
export function _resetAdblockCache(): void {
  cached = null
}
